const container = document.getElementById("slideshow-container");
const prevBtn = document.getElementById("prev");
const nextBtn = document.getElementById("next");
const slides = document.querySelectorAll(".slideshow-slide");
const indicators = document.querySelectorAll(".slideshow-indicator");
let currentSlide = 0;

function showSlide(index: number) {
  slides.forEach((slide, i) => {
    slide.classList.toggle("block", i === index);
    slide.classList.toggle("hidden", i !== index);
  });

  indicators.forEach((indicator, i) => {
    indicator.classList.toggle("bg-primary", i === index);
    indicator.classList.toggle("bg-stroke", i !== index);
  });
}

prevBtn?.addEventListener("click", () => {
  currentSlide = (currentSlide - 1 + slides.length) % slides.length;
  showSlide(currentSlide);
});

nextBtn?.addEventListener("click", () => {
  currentSlide = (currentSlide + 1) % slides.length;
  showSlide(currentSlide);
});

indicators.forEach((indicator, i) => {
  indicator.addEventListener("click", () => {
    currentSlide = i;
    showSlide(currentSlide);
  });
});

// TODO: Handle Touch Events

// Initialize the slideshow
showSlide(currentSlide);
